import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cx-unit-name-filter" }

import { computed } from 'vue';
import { gettext } from '@/translations/gettext.setup';
import translationService from '@/services/translation.service';
import { Unit } from '@/domain/units/Unit';
import NCxSelect from '@/components/NCxSelect.vue';

interface Props {
  availableUnits: Unit[],
  selectedUnits: Unit[],
  updateSelection: Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CxUnitNameFilter',
  props: {
    availableUnits: {},
    selectedUnits: {},
    updateSelection: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const { $gettext } = gettext;



const filterItems = computed(() => {
  return props.availableUnits
    .map(u => ({
      id: u.uuid,
      title: u.name,
      subtitle: translationService.get(u.entityType)
    }));
});

const selectedItems = computed(() => props.selectedUnits.map(u => u.uuid));

const translations = computed(() => ({
  unitNameFilter: $gettext('Unit names'),
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NCxSelect, {
      items: filterItems.value,
      selectedItemIds: selectedItems.value,
      "onUpdate:selectedItemIds": props.updateSelection,
      activatorPlaceholder: translations.value.unitNameFilter,
      multiselect: true
    }, null, 8, ["items", "selectedItemIds", "onUpdate:selectedItemIds", "activatorPlaceholder"])
  ]))
}
}

})